import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNecklaceWomen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.6276 3.33333C21.211 2.5 20.3776 2 19.4609 2H4.37762C3.54428 2 2.71095 2.5 2.29428 3.33333C1.87762 4.16667 1.87762 5.16667 2.46095 5.91667L10.0443 17.0833L8.87762 18.25C8.62762 18.5 8.62762 18.9167 8.87762 19.1667L11.5443 21.8333C11.6276 21.9167 11.7943 22 11.9609 22C12.1276 22 12.2943 21.9167 12.3776 21.8333L15.0443 19.1667C15.2943 18.9167 15.2943 18.5 15.0443 18.25L13.8776 17.0833L21.4609 5.91667C22.0443 5.16667 22.1276 4.16667 21.6276 3.33333ZM11.9609 20.5L10.2109 18.75L11.9609 17L13.7109 18.75L11.9609 20.5ZM20.461 5.25L12.9609 16.25L12.3776 15.6667C12.1276 15.4167 11.7109 15.4167 11.4609 15.6667L10.8776 16.25L3.37762 5.25C3.12762 4.83333 3.12762 4.33333 3.37762 3.91667C3.54428 3.5 3.96095 3.25 4.46095 3.25H19.4609C19.8776 3.25 20.2943 3.5 20.5443 3.91667C20.7943 4.33333 20.7943 4.83333 20.461 5.25Z",
		fill: "currentColor"
	})
});
export default SvgNecklaceWomen;
